const { VITE_APP_STAGE } = import.meta.env;

const ApiList = {
  login: `https://5lkru1km8h.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  utils: `https://5l6boywm97.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  profile: `https://rh8swmj6we.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  preSigned: `https://2v2p4mm63c.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  integrated: `https://7q63conwve.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  talentDev: `https://rh8swmj6we.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
  talentProd: `https://rh8swmj6we.execute-api.us-east-2.amazonaws.com/${VITE_APP_STAGE}`,
};

export default ApiList;
